import _ from "lodash";
import React from "react";
import classes from "./PYPElements.scss";
import { colors, fontStyle } from "Constants";
import { shouldShowFlatListForType } from "AppComponents/DatasetTaggingBody/modules/Utils";

import Accordian from "UIComponents/Accordian";
import Textview from "UIComponents/Textview";
import Listview from "UIComponents/Listview";
import BenchmarkView from "UIComponents/BenchmarkView";
import I18nHOC from "UIComponents/I18nHOC";
import GenericListView from "UIComponents/GenericListView";
import classNames from "classnames";
import { getIsSubjectStandard } from "Teacher/routes/Courses/routes/Course/routes/ClassRoom/modules/utils";

const CONTAINER_STYLES = {
  labelStyle: {
    fontSize: "1.6rem",
    ...fontStyle.demiBold,
  },
  labelContainerStyle: {
    marginBottom: 8,
  },
  containerStyle: {
    borderBottom: `1px solid ${colors.strokeTwo}`,
    padding: "8px 0",
  },
  noBorderTop: {
    borderTop: "0px",
  },
};

const getElementLabel = ({
  hideLabel,
  isSubjectStandard,
  showStandardsLabel,
  itemLocalisedLabel,
  itemLabel,
  standardLabel,
  t,
  showInAccordian,
  nonAccordionListLabel,
}) => {
  if (!showInAccordian) {
    if (hideLabel && isSubjectStandard) {
      return "";
    }

    const isSubjectStandardsItem =
      _.isEqual(itemLocalisedLabel, "Subject Standards") ||
      _.isEqual(itemLabel, "Subject Standards");

    if (showStandardsLabel && isSubjectStandardsItem) {
      return t("common:standard_plural");
    }

    const hasStandardLabel =
      !_.isNil(standardLabel) || !_.isUndefined(standardLabel);

    if (hasStandardLabel && showStandardsLabel && isSubjectStandard) {
      return standardLabel ?? (itemLocalisedLabel || t(itemLabel));
    }

    return itemLocalisedLabel || t(itemLabel);
  } else return nonAccordionListLabel;
};

const PYPElementsDetails = ({
  pypTemplateElements,
  elementData,
  showViewEmpty,
  shouldPypElementEmptyContainer,
  t,
  itemContainerClass,
  theme,
  dynamicLevelContainerStyle = {},
  childrenContainerStyle = [],
  customContainerStyle = {},
  showInAccordian = false,
  addSeparators = false,
  defaultAccodianExpanded,
  customRightArrow,
  showLabelBorder = true,
  showDesignV2 = false,
  customTitleStyle = {},
  customTextStyle = {},
  detailDataContainerStyle = {},
  showDPLpaInTextView = false,
  showStandardsLabel = false,
  skipNodeLevelCheck = false,
  hideLabel = false,
  showDiscAtAllLevel = false,
  standardLabel,
  showSetTitle = false,
}) => {
  let isPypElementEmpty = true;
  _.forEach(elementData, element => {
    if (_.get(element, "length", 0) != 0) {
      isPypElementEmpty = false;
      return false;
    }
  });

  const getValue = ({ value }) => {
    if (_.includes(value, "disciplinaryObjectivesMYP")) {
      return "disciplinaryObjectivesMYP";
    }
    if (_.includes(value, "disciplinaryLearningStandardMYP")) {
      return "disciplinaryLearningStandardMYP";
    }
    return value;
  };

  const getFirstElementUid = () => {
    let firstElementUid = "";
    let elementIndex = _.get(pypTemplateElements, "length", 0);

    _.forEach(elementData, (element, key) => {
      const index = _.findIndex(
        pypTemplateElements,
        item => item?.value === key
      );
      if (index < elementIndex && !_.isEmpty(element)) {
        firstElementUid = key;
        elementIndex = index;
      }
    });

    return firstElementUid;
  };

  const getFlatListComponent = ({ values, label }) => {
    const flatListContainerClasses = classNames({
      [classes.flatListContainer]: !label,
    });

    let rootNodesIds = _.map(
      _.filter(values, item => _.get(item, "isRootNode")),
      "id"
    );

    if (_.isEmpty(rootNodesIds)) rootNodesIds = _.map(values, "id");
    return (
      <div className={flatListContainerClasses}>
        <GenericListView
          nodes={values}
          rootNodeIds={rootNodesIds}
          label={label}
        />
      </div>
    );
  };

  const getRenderComponent = ({ item, firstElementUid }) => {
    let renderComponent = null;
    const values = _.get(elementData, item.value, []);
    const { labelStyle = {}, labelContainerStyle = {} } = theme || {};
    const showInAccordianStyle = showInAccordian
      ? {
          labelStyle: {
            color: colors.neutral200,
          },
          containerStyle: {
            marginTop: "-8px",
          },
        }
      : {};
    const value = getValue({ value: item.value });
    const isFirstElement = value === firstElementUid;
    const isSubjectStandard = getIsSubjectStandard({ type: item.elementType });
    if (_.get(values, "length", 0) === 0) return renderComponent;
    switch (value) {
      case "benchmarks":
      case "atls":
      case "atlsMYP":
      case "learningStandardMYP":
      case "objectivesMYP":
      case "disciplinaryObjectivesMYP":
      case "disciplinaryLearningStandardMYP":
      case "atlsUBD":
      case "learningStandardUBD":
      case "atlDP":
      case "learnerProfileDP":
      case "syllabusContentDP":
      case "subjectStandardDP":
      case "interdisciplinaryCriteriaMYP": {
        const { showFlatList } = shouldShowFlatListForType({
          plannerElementType: item.elementType,
        });
        const nonAccordionListLabel = !showInAccordian
          ? hideLabel && isSubjectStandard
            ? ""
            : showStandardsLabel &&
              (_.isEqual(item.localisedLabel, "Subject Standards") ||
                _.isEqual(item.label, "Subject Standards"))
            ? t("common:standard_plural")
            : item.localisedLabel || t(item.label)
          : null;
        if (showFlatList) {
          return getFlatListComponent({
            values,
            label: nonAccordionListLabel,
          });
        }
        renderComponent = showInAccordian ? (
          <Accordian
            key={item.value}
            title={item.localisedLabel || t(item.label)}
            customTitleStyle={{
              ...CONTAINER_STYLES.labelStyle,
              ...showInAccordianStyle.labelStyle,
              ...customTitleStyle,
            }}
            headerStyle={
              showDesignV2
                ? { padding: "8px 0px" }
                : { padding: "8px 0 12px 0" }
            }
            hideContainerBorder={true}
            mainContainerClass={classes.accordianMainContainerClass}
            mainContentContainerStyle={{ paddingBottom: "-8px" }}
            customHeaderClass={classes.accordianHeaderClass}
            customArrowContainerClass={
              showDesignV2
                ? classes.accordianArrowContainerClassV2
                : classes.accordianArrowContainerClass
            }
            customRightArrow={customRightArrow ? customRightArrow : null}
            showLabelBorder={showLabelBorder}
            getExpandedContent={() =>
              value === "learnerProfileDP" ? (
                <Textview
                  key={item.value}
                  mode={"view"}
                  showViewEmpty={showViewEmpty}
                  value={values}
                  labelStyle={{ ...CONTAINER_STYLES.labelStyle, ...labelStyle }}
                  labelContainerStyle={{
                    ...CONTAINER_STYLES.labelContainerStyle,
                    ...labelContainerStyle,
                  }}
                  containerStyle={{
                    ...CONTAINER_STYLES.containerStyle,
                    ...customContainerStyle,
                    ...(isFirstElement && CONTAINER_STYLES.noBorderTop),
                  }}
                  customTextStyle={customTextStyle}
                />
              ) : (
                <BenchmarkView
                  labelComponent={<span></span>}
                  value={values}
                  mode={"view"}
                  showViewEmpty={showViewEmpty}
                  labelStyle={{
                    ...CONTAINER_STYLES.labelStyle,
                    ...labelStyle,
                  }}
                  labelContainerStyle={{
                    ...labelContainerStyle,
                  }}
                  containerStyle={{
                    ...customContainerStyle,
                    ...showInAccordianStyle.containerStyle,
                  }}
                  dynamicLevelContainerStyle={{ ...dynamicLevelContainerStyle }}
                  childrenContainerStyle={childrenContainerStyle}
                  showDiscAtSecondLevel={showDesignV2}
                  showSetTitle={showSetTitle}
                />
              )
            }
            titleStyleCustom={
              showDesignV2 ? { fontSize: "1.6rem", lineHeight: "2.2rem" } : {}
            }
            isExpanded={defaultAccodianExpanded}
          />
        ) : value === "learnerProfileDP" && showDPLpaInTextView ? (
          <Textview
            key={item.value}
            label={item.localisedLabel || t(item.label)}
            mode={"view"}
            showViewEmpty={showViewEmpty}
            value={values}
            labelStyle={{ ...CONTAINER_STYLES.labelStyle, ...labelStyle }}
            labelContainerStyle={{
              ...CONTAINER_STYLES.labelContainerStyle,
              ...labelContainerStyle,
            }}
            containerStyle={{
              ...CONTAINER_STYLES.containerStyle,
              ...customContainerStyle,
              ...(isFirstElement && CONTAINER_STYLES.noBorderTop),
            }}
            customTextStyle={customTextStyle}
          />
        ) : (
          <BenchmarkView
            key={item.value}
            label={getElementLabel({
              hideLabel,
              isSubjectStandard,
              showStandardsLabel,
              itemLocalisedLabel: item.localisedLabel,
              itemLabel: item.label,
              standardLabel,
              t,
              showInAccordian,
              nonAccordionListLabel,
            })}
            value={values}
            mode={"view"}
            showViewEmpty={showViewEmpty}
            labelStyle={{
              ...CONTAINER_STYLES.labelStyle,
              ...labelStyle,
            }}
            labelContainerStyle={{
              ...CONTAINER_STYLES.labelContainerStyle,
              ...labelContainerStyle,
            }}
            containerStyle={{
              ...CONTAINER_STYLES.containerStyle,
              ...customContainerStyle,
              ...(isFirstElement && CONTAINER_STYLES.noBorderTop),
            }}
            dynamicLevelContainerStyle={{ ...dynamicLevelContainerStyle }}
            childrenContainerStyle={childrenContainerStyle}
            showDiscAtSecondLevel={showDesignV2}
            showStandardsLabel={showStandardsLabel && isSubjectStandard}
            skipNodeLevelCheck={skipNodeLevelCheck && isSubjectStandard}
            showDiscAtAllLevel={showDiscAtAllLevel && isSubjectStandard}
            showSetTitle={showSetTitle}
          />
        );
        break;
      }
      case "lois":
        renderComponent = (
          <Listview
            key={item.value}
            label={item.localisedLabel || t(item.label)}
            value={values}
            mode={"view"}
            showViewEmpty={showViewEmpty}
            labelStyle={{ ...CONTAINER_STYLES.labelStyle, ...labelStyle }}
            labelContainerStyle={{
              ...CONTAINER_STYLES.labelContainerStyle,
              ...labelContainerStyle,
            }}
            containerStyle={{
              ...CONTAINER_STYLES.containerStyle,
              ...customContainerStyle,
              ...(isFirstElement && CONTAINER_STYLES.noBorderTop),
            }}
          />
        );
        break;

      default:
        renderComponent = (
          <Textview
            key={item.value}
            label={item.localisedLabel || t(item.label)}
            mode={"view"}
            showViewEmpty={showViewEmpty}
            value={values}
            labelStyle={{ ...CONTAINER_STYLES.labelStyle, ...labelStyle }}
            labelContainerStyle={{
              ...CONTAINER_STYLES.labelContainerStyle,
              ...labelContainerStyle,
            }}
            containerStyle={{
              ...CONTAINER_STYLES.containerStyle,
              ...customContainerStyle,
              ...(isFirstElement && CONTAINER_STYLES.noBorderTop),
            }}
            customTextStyle={customTextStyle}
          />
        );
    }
    return renderComponent;
  };

  const containerContainerClasses = classNames({
    [classes.itemContainer]: true,
    [itemContainerClass]: !!itemContainerClass,
    [classes.separatorsPadding]: addSeparators,
  });

  const detailDataContainerClasses = classNames({
    [classes.detailDataContainer]: true,
    [classes.separators]: addSeparators,
  });

  const firstElementUid = getFirstElementUid();

  return isPypElementEmpty && shouldPypElementEmptyContainer ? (
    <div className={classes.subDetailEmptyContainer}>
      <div className={classes.detailText}>{t("common:no_pyp_elements")}</div>
    </div>
  ) : (
    <div
      className={detailDataContainerClasses}
      style={detailDataContainerStyle}
      data-test-id="pyp-elements-details"
    >
      {_.map(pypTemplateElements, item => {
        const renderComponent = getRenderComponent({
          item,
          firstElementUid,
          hideLabel,
        });
        return renderComponent ? (
          <div key={_.get(item, "value")} className={containerContainerClasses}>
            {renderComponent}
          </div>
        ) : null;
      })}
    </div>
  );
};

export default I18nHOC({ resource: "common" })(PYPElementsDetails);

PYPElementsDetails.defaultProps = {
  showViewEmpty: false,
  shouldPypElementEmptyContainer: true,
  customContainerStyle: {},
};
